import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // 이게 빠져있으면 안 돼!
import App from "./App";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// --- PWA: 서비스워커 등록 (배포 환경에서만 동작) ---
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // 새 SW가 내려오면(업데이트 발견)
      reg.onupdatefound = () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.onstatechange = () => {
          // 기존 SW가 페이지를 제어 중이라면 = 업데이트 상황
          if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
            // 대기 중인 SW를 즉시 활성화
            reg.waiting?.postMessage({ type: 'SKIP_WAITING' });
          }
        };
      };
      // 새 SW가 실제로 컨트롤을 잡는 순간 1회 리로드하여 최신 자산 사용
      let refreshed = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshed) return;
        refreshed = true;
        window.location.reload();
      });
    }).catch((err) => {
      console.warn('[SW] register failed:', err);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
